
import { Component, Mixins } from 'vue-property-decorator';

import BaseExperiment from '@/components/experiments/Core/BaseExperiment.vue';
import {
	PopularProviderPageExpName,
	PopularProviderPageExpVariantName,
} from '@/enums/experiments/popular-provider-page-exp';
import { namespace } from 'vuex-class';

const User = namespace('user');
//?preferred_variant=POPULAR-PROVIDER-PAGE-EXP:control
// ?preferred_variant=POPULAR-PROVIDER-PAGE-EXP:variant_1
@Component({ name: 'PopularProviderPageExp' })
export default class PopularProviderPageExp extends Mixins(BaseExperiment) {
	static id = PopularProviderPageExpName;
	@User.Getter isLoggedIn: () => boolean;

	name = PopularProviderPageExp.id;
	variants = [
		{ name: PopularProviderPageExpVariantName.CONTROL, weight: 1 },
		{ name: PopularProviderPageExpVariantName.VARIANT_1, weight: 1 },
	];
	goals = [];

	async onReady() {
		if (!this.isLoggedIn()) {
			this.trigger();
		}
	}
}
